import KpiCard from './KpiCard'
import type { ScoreboardStats } from '../../types'

export default function ScoreboardKpiCard({ stats, teamId }: { stats: ScoreboardStats; teamId: number }) {
  const total = stats.on_track_count + stats.off_track_count
  const ratio = total > 0 ? stats.on_track_count / total : 0
  const color = total === 0 ? 'neutral' : ratio >= 0.8 ? 'green' : ratio >= 0.5 ? 'amber' : 'red'
  const subtitle = stats.off_track_count > 0 ? `${stats.off_track_count} off track` : 'All metrics on track'

  return (
    <KpiCard
      label="Scoreboard"
      value={total > 0 ? `${stats.on_track_count}/${total} on track` : `${stats.total_metrics} metrics`}
      subtitle={total > 0 ? subtitle : 'No data yet'}
      href={`/teams/${teamId}/scoreboard`}
      statusColor={color}
      icon={
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <line x1="18" y1="20" x2="18" y2="10" />
          <line x1="12" y1="20" x2="12" y2="4" />
          <line x1="6" y1="20" x2="6" y2="14" />
        </svg>
      }
    />
  )
}
